import { tosApi } from './tosApi';

export const brandingApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getBranding: build.query<Record<string, string>, string>({
      query: (domain) => {
        return {
          url: `/core/branding?domain=${domain}`,
          method: 'GET',
        };
      },

      transformResponse: (response: { key: string; value: string }[]) => {
        const branding: Record<string, string> = {};

        response.forEach((item) => {
          branding[item.key] = item.value;
        });

        return branding;
      },

      providesTags: [{ type: 'Branding' }],
    }),
  }),

  overrideExisting: true,
});

export const { useGetBrandingQuery } = brandingApi;
